var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 257 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.972 8.13214C123.884 3.25623 133.116 3.25624 140.028 8.13215L231.313 72.5241C236.625 76.2713 239.784 82.3665 239.784 88.8672V225.133C239.784 231.634 236.625 237.729 231.313 241.476L140.028 305.868C133.116 310.744 123.884 310.744 116.972 305.868L25.6873 241.476C20.3752 237.729 17.2157 231.634 17.2157 225.133V88.8672C17.2157 82.3665 20.3752 76.2713 25.6873 72.5241L116.972 8.13214Z",
    fill: "#4176FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.65 70.8224C124.484 66.1126 133.516 66.1126 140.35 70.8224L189.632 104.788C195.048 108.521 198.282 114.678 198.282 121.256V195.744C198.282 202.322 195.048 208.479 189.632 212.212L140.35 246.178C133.516 250.887 124.484 250.887 117.65 246.178L68.3683 212.212C62.9523 208.479 59.718 202.322 59.718 195.744V121.256C59.718 114.678 62.9523 108.521 68.3683 104.788L117.65 70.8224Z",
    fill: "#89A9FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGem);
export default __webpack_public_path__ + "static/media/Gem.67402e98aa7d707fb93bad20c9dec481.svg";
export { ForwardRef as ReactComponent };